const havePremiumPrice = (product): boolean => {
  const subPrices = product?.prices_current_subscription || []

  return subPrices.length > 0
}

export default havePremiumPrice
